import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        navShow: false,
        screenWidth: 0,
        suggest: {
            user: '',
            email: '',
            driver: '',
            score: 0,
            content: ''
        },
        pickup: {
            date: '',
            time: '',
            seat: '',
            style: '',
            sign: '',
            safe: '',
            fromPlace: '',
            toPlace: ''
        },
        charter: {
            date: '',
            time: '',
            seat: '',
            style: '',
            sign: '',
            safe: '',
            days: ''
        },
        track: {
            email: '',
            user: ''
        },
        qa: [
            { q: '請問你們車輛的合法性與保險?', a: '本公司為政府立案的合法乙種租賃車公司，(租賃車牌為R開頭，例RAE-xxxx)非一般自用車或小黃計程車，每輛車均投保4000萬乘客險，非團保。' },
            { q: '請問松山機場有接送服務嗎?', a: '有的，各個機場均有接送服務，歡迎預約。' },
            { q: '請問付款方式?', a: '訂車完成後即可使用線上刷卡付費。如後續想付費或查詢付費狀況，可至訂單查詢執行。' },
            { q: '請問訂車取消方式?', a: '請撥客服專線或使用Line線上客服取消 (最慢應行程前一天取消，否則將收取1/2車資)。' },
            { q: '有沒有提供外語服務?', a: '請撥客服專線或使用Line線上客服，我們將為您安排。' },
            { q: '有沒有提供長期用車服務?', a: '歡迎公司行號，團體來電洽詢，採簽約月結方式長期合作。' },
            { q: '請問車費中有涵蓋保險或是其他費用嗎?', a: '車費中包含駕駛服務費、汽車燃料費、高速公路過路費，並且每人投保700萬元人身意外險和旅平險。' }
        ],
        site: [
            { title: '台北', content: '台北建議景點行程', src: require('@/components/site/img/taipei.jpg') },
            { title: '桃園', content: '桃園建議景點行程', src: require('@/components/site/img/taoyuan.jpg') },
            { title: '新竹', content: '新竹建議景點行程', src: require('@/components/site/img/hsinchu.jpg') },
            { title: '苗栗', content: '苗栗建議景點行程', src: require('@/components/site/img/miaoli.jpg') },
            { title: '台中', content: '台中建議景點行程', src: require('@/components/site/img/taichung.jpg') },
            { title: '南投', content: '南投建議景點行程', src: require('@/components/site/img/nantou.jpg') },
            { title: '彰化', content: '彰化建議景點行程', src: require('@/components/site/img/changhua.jpg') },
            { title: '雲林', content: '雲林建議景點行程', src: require('@/components/site/img/yunlin.jpg') },
            { title: '嘉義', content: '嘉義建議景點行程', src: require('@/components/site/img/chiayi.jpg') },
            { title: '台南', content: '台南建議景點行程', src: require('@/components/site/img/tainan.jpg') },
            { title: '高雄', content: '高雄建議景點行程', src: require('@/components/site/img/kaohsiung.jpg') },
            { title: '墾丁', content: '墾丁建議景點行程', src: require('@/components/site/img/kenting.jpg') },
            { title: '宜蘭', content: '宜蘭建議景點行程', src: require('@/components/site/img/yilan.jpg') },
            { title: '花蓮', content: '花蓮建議景點行程', src: require('@/components/site/img/hualien.jpg') },
            { title: '台東', content: '台東建議景點行程', src: require('@/components/site/img/taitung.jpg') }
        ],
        carousel: [
            { src: require('@/components/carousel/img/header-2.jpg'), title: '深森旅微笑旅行 Smile to travel !', subTitle: '包車旅遊 機場接送 第一首選', btn: '立即訂車' },
            { src: require('@/components/carousel/img/header.jpg'), title: '機場接送、點對點接送自由行用車', subTitle: '帶給您最便利及最貼心的用車體驗。', btn: '立即訂車' },
            { src: require('@/components/carousel/img/header-4.jpg'), title: '包車旅遊', subTitle: '帶您深入台灣，飽覽台灣之美。', btn: '立即訂車' }
        ],
        carousel2: [
            { src: require('@/views/order/img/20180128144135.jpg') },
            { src: require('@/views/order/img/20180204175731.jpg') },
            { src: require('@/views/order/img/20180128143953.jpg') },
            { src: require('@/views/order/img/20180204173849.jpg') },
            { src: require('@/views/order/img/20180128143818.jpg') },
            { src: require('@/views/order/img/20180128143739.jpg') },
            { src: require('@/views/order/img/20180128143702.jpg') }
        ]
    },
    mutations: {
        NAVHANDLER(state, payload) {
            if (payload) {
                state.navShow = false;
            } else {
                state.navShow = !state.navShow;
            }
        },
        SCREENWIDTH(state, payload) {
            state.screenWidth = payload;
        },
        // 評價司機
        SUGGESTUSER(state, payload) {
            state.suggest.user = payload;
        },
        SUGGESTEMAIL(state, payload) {
            state.suggest.email = payload;
        },
        SUGGESTDRIVER(state, payload) {
            state.suggest.driver = payload;
        },
        SUGGESTSCORE(state, payload) {
            state.suggest.score = payload;
        },
        SUGGESTCONTENT(state, payload) {
            state.suggest.content = payload;
        },

        // 接送服務
        PICKUPDATE(state, payload) {
            state.pickup.date = payload;
        },
        PICKUPTIME(state, payload) {
            state.pickup.time = payload;
        },
        PICKUPSEAT(state, payload) {
            state.pickup.seat = payload;
        },
        PICKUPSTYLE(state, payload) {
            state.pickup.style = payload;
        },
        PICKUPSIGN(state, payload) {
            state.pickup.sign = payload;
        },
        PICKUPSAFE(state, payload) {
            state.pickup.safe = payload;
        },
        PICKUPFROMPLACE(state, payload) {
            state.pickup.fromPlace = payload;
        },
        PICKUPTOPLACE(state, payload) {
            state.pickup.toPlace = payload;
        },
        // 包車服務
        CHARTERDATE(state, payload) {
            state.charter.date = payload;
        },
        CHARTERTIME(state, payload) {
            state.charter.time = payload;
        },
        CHARTERSEAT(state, payload) {
            state.charter.seat = payload;
        },
        CHARTERSTYLE(state, payload) {
            state.charter.style = payload;
        },
        CHARTERSIGN(state, payload) {
            state.charter.sign = payload;
        },
        CHARTERSAFE(state, payload) {
            state.charter.safe = payload;
        },
        CHARTERDAYS(state, payload) {
            state.charter.days = payload;
        },

        // 訂單查詢
        TRACKUSER(state, payload) {
            state.track.user = payload;
        },
        TRACKEMAIL(state, payload) {
            state.track.email = payload;
        }
    },
    actions: {},
    modules: {},
    getters: {
        labelPosition(state) {
            if (state.screenWidth < 1208) {
                return 'top';
            } else {
                return 'right';
            }
        }
    }
});
